import {apiRequest} from '../api/client';
type Submission={body:string;key:string};
const records=new Map<string,Submission>();
const pending=new Map<string,Promise<unknown>>();
// A retry after a lost response must identify the original job, including
// after navigating away and returning. A confirmed success starts a new intent.
export function submitGeneration(scope:string,body:string):Promise<unknown>{
  const storageKey=`vgen.pending-submission:${scope}`;
  let record=records.get(scope);
  if(!record){try{const saved=JSON.parse(localStorage.getItem(storageKey)||'null') as Submission|null;if(saved&&typeof saved.body==='string'&&typeof saved.key==='string')record=saved}catch{/* Ignore an invalid persisted attempt. */}}
  if(record?.body!==body)record={body,key:crypto.randomUUID()};
  records.set(scope,record);
  try{localStorage.setItem(storageKey,JSON.stringify(record))}catch{/* In-memory identity still prevents a duplicate while this page is open. */}
  const identity=`${scope}:${record.key}`;const existing=pending.get(identity);if(existing)return existing;
  const accepted=record;
  const request=apiRequest('/api/generations',{method:'POST',headers:{'idempotency-key':record.key},body}).then(result=>{
    if(records.get(scope)?.key===accepted.key){records.delete(scope);try{localStorage.removeItem(storageKey)}catch{/* Confirmed in-memory result remains authoritative. */}}
    return result;
  }).finally(()=>pending.delete(identity));
  pending.set(identity,request);return request;
}
